import { createFileRoute } from "@tanstack/react-router";

import { MetricsHighlights } from "~/components/feature/metrics/pages";

export const Route = createFileRoute("/_app/dashboard/metrics/highlights")({
  component: RouteComponent,
});

function RouteComponent() {
  return <MetricsHighlights />;
}
